import {
    Card,
    Icon,
    IconButton,
    Modal, Table, TableBody,
    TableRow
} from '@mui/material';
import MDTypography from "components/MDTypography";
import { menus } from 'utils/Enums';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import MDBox from 'components/MDBox';
import { useMaterialUIController } from 'context';
import DataTableBodyCell from 'examples/Tables/DataTable/DataTableBodyCell';
import { useState } from 'react';


const scrollStyle = {
    padding: "12px",
    maxHeight: '80%',
    overflowY: 'auto',
    scrollbarWidth: 'thin',
    scrollbarColor: '#c0c0c0 #f5f5f5',
    '&::WebkitScrollbar': {
        width: '0px',
    }
};

const menuOrder = [
    "Meu Perfil",
    "Ferramentas",
    "Labor",
    "Processos",
    "UMC"
];

// Função para combinar as funcionalidades de todos os perfis
const combineFunctionalities = (perfils) => {
    const combined = {};

    perfils.forEach(profile => {
        if (profile.funcionalidades) {
            profile.funcionalidades.forEach(id => {
                const menu = menus[id.toLowerCase()];
                if (menu) {
                    if (!combined[menu.menu]) {
                        combined[menu.menu] = new Set();
                    }
                    combined[menu.menu].add(menu.name);
                }
            });
        }
    });

    const orderedCombined = {};
    menuOrder.forEach(menu => {
        if (combined[menu]) {
            orderedCombined[menu] = Array.from(combined[menu]);
        }
    });
    
    Object.keys(combined).forEach(menu => {
        if (!orderedCombined[menu]) {
            orderedCombined[menu] = Array.from(combined[menu]);
        }
    });

    return orderedCombined;
};

const getFunctionalityNameById = (id) => {
    const menu = menus[id.toLowerCase()];
    return menu ? menu.name : `Desconhecido (${id})`;
};

const transformIdsToCategorizedData = (ids) => {
    const categorized = {};

    ids.forEach(id => {
        const menu = menus[id.toLowerCase()]?.menu;
        if (menu) {
            if (!categorized[menu]) {
                categorized[menu] = [];
            }
            categorized[menu].push(getFunctionalityNameById(id));
        }
    });

    const orderedCategorized = {};
    menuOrder.forEach(menu => {
        if (categorized[menu]) {
            orderedCategorized[menu] = categorized[menu];
        }
    });
    
    Object.keys(categorized).forEach(menu => {
        if (!orderedCategorized[menu]) {
            orderedCategorized[menu] = categorized[menu];
        }
    });

    return orderedCategorized;
};

export default function MDModalMenus({ open, onClose, dados, isProfile }) {

    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: "40%",
        maxHeight: '80%',
        overflow: 'auto',
        borderRadius: 4,
        boxShadow: '2px 4px 8px rgba(0, 0, 0, 0.1)',
        backgroundColor: darkMode ? '#202940' : '#ffffff',
        color: darkMode ? '#ffffff' : '#000000',
        p: 4,
    };

    const categorizedData = isProfile
        ? transformIdsToCategorizedData(dados)
        : combineFunctionalities(dados);

    const [expanded, setExpanded] = useState(
        Object.keys(categorizedData).reduce((acc, key) => {
            acc[key] = true;
            return acc;
        }, {})
    );

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded({ ...expanded, [panel]: isExpanded });
    };


    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Card sx={style}>
                <MDTypography id="modal-modal-title" variant="h6" component="h2" mb={2}>
                    Funcionalidades
                </MDTypography>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{ position: 'absolute', top: 8, right: 8 }}
                >
                    <MDTypography variant="body1" lineHeight={1}>
                        <Icon color="light">close</Icon>
                    </MDTypography>
                </IconButton>

                <MDBox style={scrollStyle}>
                    {Object.entries(categorizedData).map(([menu, items], index) => (
                        items.length > 0 && ( // Verifica se há dados antes de renderizar a seção
                            <Accordion
                                key={index}
                                expanded={expanded[menu] || false}
                                onChange={handleChange(menu)}
                                sx={{
                                    boxShadow: '2px 4px 8px rgba(0, 0, 0, 0.2)',
                                    mb: 1,
                                    backgroundColor: darkMode ? '#324058' : '#ffff',
                                }}
                            >
                                <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: darkMode ? '#ffffff' : '#000000' }} />}>
                                    <MDTypography variant="h6" component="div">
                                        {menu}
                                    </MDTypography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Table sx={{ minWidth: 300 }}>
                                        <TableBody>
                                            {items.map((item, idx) => (
                                                <TableRow key={idx}>
                                                    <DataTableBodyCell>
                                                        {item}
                                                    </DataTableBodyCell>
                                                </TableRow>
                                            ))}
                                            {items.length === 0 && (
                                                <TableRow>
                                                    <DataTableBodyCell colSpan={2} align="center">
                                                        Nenhum menu disponível
                                                    </DataTableBodyCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </AccordionDetails>
                            </Accordion>
                        )
                    ))}
                </MDBox>
            </Card>
        </Modal>
    );
}
